import React, { FC } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { Typography700 } from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/KnowBeforeRideSection/KnowBeforeRideSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const KnowBeforeRideSection: FC<any> = () => {
  const content = useContent('MembershipLandingPage');
  return (
    <StyledBox>
      <Container maxWidth="xl">
        <Typography700 variant='h3' component="h2" mb={10}>
            {content.knowBeforeRideSectionTitle}
        </Typography700>
        <Grid container columnSpacing={4} rowSpacing={{ md: 8, sm: 4 }}>
          {content.knowBeforeRideItems.map((item) => (
            <Grid item lg={4} md={6} sm={12} key={item.title}>
              <Box >
                <Typography700 variant='h6' component="p" mb={2}>
                  {item.title}
                </Typography700>
                <Typography variant='body2' component="p">
                  {item.description}
                </Typography>
              </Box>
            </Grid>  
          ))}
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { KnowBeforeRideSection };